<script setup lang="ts">
import MaximumWorkingHoursByDaily from '@/components/OperationOfficeForms/MaximumWorkingHoursByDaily.vue';
import MaximumWorkingHoursMonthly from '@/components/OperationOfficeForms/MaximumWorkingHoursMonthly.vue';
import OperationOfficeSettingsMonthlyReport from '@/types/OperationOfficeSettingsMonthlyReport';
import { computed } from 'vue';
import i18n from '@/lang/i18n';

const emit = defineEmits(['update:modelValue'])

const props = defineProps<{
  modelValue: OperationOfficeSettingsMonthlyReport
  errors: { [key: string]: string[] }
  windowInnerWidth: number
}>()

const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit("update:modelValue", value)
  }
})
</script>
<template>
  <div class="working-hours-setting-form">
    <v-row class="radio-form pl-4 pr-3 mb-2">
      <v-col :cols="props.windowInnerWidth > 800 ? 2 : 3">
        <h6 class="pt-2 pl-4" style="font-weight: bold">
          {{ i18n.global.t('pages.operationOffices.form.maximumWorkingHours.title') }}
        </h6>
      </v-col>
      <v-col
        :cols="
          props.windowInnerWidth <= 800 ||
          (props.windowInnerWidth >= 992 && props.windowInnerWidth <= 1197)
            ? 6
            : 3
        "

      >
        <v-radio-group
          v-model="modelValue.over_time_thresholds_type"
          class="radio-group-row"
        >
          <v-radio
            value="0"
            :label="i18n.global.t('pages.operationOffices.form.maximumWorkingHours.daysSetting')"
            color="blue"
          />
          <v-radio
            value="1"
            :label="i18n.global.t('pages.operationOffices.form.maximumWorkingHours.monthSetting')"
            color="blue"
          />
        </v-radio-group>
      </v-col>
    </v-row>
    <v-row
      v-if="modelValue.over_time_thresholds_type == 0"
      class="radio-form pl-4 pr-3 mb-2"
    >
      <MaximumWorkingHoursByDaily
        v-model="modelValue.over_time_thresholds.daily"
        :errors="errors"
        :windowInnerWidth="props.windowInnerWidth"
      />
    </v-row>
    <template
      v-if="modelValue.over_time_thresholds_type == 1"
    >
      <v-row
        v-for="(time, month) in modelValue.over_time_thresholds.monthly"
        :key="month"
        class="pl-4 pr-3 mb-2"
      >
        <MaximumWorkingHoursMonthly
          v-model="modelValue.over_time_thresholds.monthly[month]"
          :month="month"
          :errors="errors"
          :windowInnerWidth="windowInnerWidth"
        />
      </v-row>
    </template>
  </div>
</template>
<style scoped>
.radio-form .radio-group-row .v-selection-control-group {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.working-hours-setting-form .v-label {
  font-size: 14px;
}
</style>
